import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import Signup from "./Signup";

/**
 * Convenience route `/investor/join` — a marketing-friendly URL that
 * always renders the investor-intent Signup surface.
 *
 * NOTE: `intent="investor"` MUST be passed to `<Signup />` — without it,
 * Signup defaults to `intent="equity"` and creates the user with
 * `role="startup"` (that was the bug reported on 2026-02-20).
 */
export default function InvestorJoin() {
  const { user } = useAuth();
  if (user?.role === "investor") return <Navigate to="/investor/preferences" replace />;
  if (user && user.role !== "investor") return <Navigate to="/marketplace" replace />;
  window.history.replaceState(null, "", "/for-investors/signup");
  return <Signup intent="investor" />;
}
